import React, {useState} from 'react';
import {Business} from './Business';
import BusinessCard from './BusinessCard';
import BusinessForm from './BusinessForm';
import {Card, CardMedia, Grid, IconButton} from "@mui/material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {includes, toLower} from "lodash";
import {ADMINS} from "./Constants";

interface BusinessListProps {
  businesses: Business[];
  onSave: (business: Business) => void;
  addBusiness: () => void;
  cancelAdd: () => void;
  adminName: string;
  setError: (error: string) => void;
}

function BusinessList({
                        businesses,
                        setError,
                        onSave,
                        addBusiness,
                        cancelAdd,
                        adminName
                      }: BusinessListProps) {
  const [businessBeingEdited, setBusinessBeingEdited] = useState({});
  const handleEdit = (business: Business) => {
    console.log(business);
    setBusinessBeingEdited(business);
  }
  const cancelEditing = () => {
    setError('');
    setBusinessBeingEdited({});
  }
  return (
      <Grid container rowSpacing={6} spacing={6} justifyContent="center" alignItems={'center'}>
        {businesses.map((business) => (
            <Grid item key={business.id}>
              {(business === businessBeingEdited) || !(business.id)
                  ? (<BusinessForm
                      business={business}
                      onCancel={business.id ? cancelEditing : cancelAdd}
                      onSave={onSave}/>) :
                  (<BusinessCard business={business} onEdit={handleEdit}
                                 adminName={adminName}></BusinessCard>)}
            </Grid>
        ))}
        { includes(ADMINS, toLower(adminName)) && (businesses.length === 0 || businesses.slice(-1)[0].id) &&
            <Grid item key='new' alignItems={'center'}>
              <Card>
                <CardMedia>
                  <IconButton onClick={addBusiness}>
                    <AddCircleIcon sx={{fontSize: 70}}/>
                  </IconButton>
                </CardMedia>
              </Card>
            </Grid>
        }
      </Grid>
  );
}

export default BusinessList;